import React, { Fragment, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'

const AnnotatedWord = props => {
  const { word, annotations } = props
  const [acceptedSuggestion, setAcceptedSuggestion] = useState('')

  const handleAcceptSuggestion = s => () => {
    setAcceptedSuggestion(s)
  }

  return acceptedSuggestion ? (
    acceptedSuggestion
  ) : (
    <mark className={annotations[0].class}>
      {word}
      <div className="annotation">
        {annotations.map((annotation, index) => {
          const suggestions = annotation.suggestion.split(', ')
          return (
            <div className="annotation-item" key={index}>
              <div className="suggestion">
                {suggestions.map((suggestion, index) => (
                  <Fragment key={suggestion}>
                    {index > 0 ? ', ' : null}
                    <span
                      onClick={handleAcceptSuggestion(suggestion)}
                    >
                      {suggestion}
                    </span>
                  </Fragment>
                ))}
              </div>
              {annotation.label ? (
                <div className="label">{annotation.label}</div>
              ) : null}
              {annotation.explanation ? (
                <div className="explanation">
                  {ReactHtmlParser(annotation.explanation)}
                </div>
              ) : null}
            </div>
          )
        })}
      </div>
    </mark>
  )
}

export default AnnotatedWord
